import {
  faExclamationTriangle,
  faInfoCircle,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { ReactNode, Component } from 'react';
import { locale } from '../../common/localization/localizationService';

import './WarningBanner.scss';
import { Spinner } from 'react-bootstrap';

export interface IWarningBannerProps {
  hidden: boolean;
  isCompact?: boolean;
  text: string;
  type?: 'info' | 'warning' | 'loading';
  onClick?: () => void;
  onAnchor?: () => void;
  anchor?: string;
}
export class WarningBanner extends Component<IWarningBannerProps> {
  public onClick(): void {
    if (this.props.onClick) this.props.onClick();
  }

  public onAnchor(): void {
    if (this.props.onAnchor) this.props.onAnchor();
  }

  public render(): ReactNode {
    const { hidden, text, type, anchor, isCompact } = this.props;
    const isInfo = type === 'info';
    const isLoading = type === 'loading';
    const icon = isInfo ? faInfoCircle : faExclamationTriangle;
    if (hidden) return null;
    return (
      <div
        className={`warning-banner ${isCompact ? 'compact' : ''} ${
          isInfo || isLoading ? 'info' : 'warn'
        }`}
      >
        <div
          className="banner"
          onClick={() => this.onClick()}
          style={{ cursor: this.props.onClick ? 'pointer' : 'auto' }}
        >
          {!isInfo && !isLoading && <FontAwesomeIcon icon={icon} />}
          {isLoading && (
            <div>
              <Spinner className="banner-loading-spinner" animation="grow" />
            </div>
          )}
          <p>
            {!isInfo && !isLoading && (
              <strong>{locale.general._warning}</strong>
            )}
            <span className="warning-banner-text">{` ${text}`}</span>
            {anchor && (
              <span
                className="anchor"
                onClick={() => this.onAnchor()}
              >{` ${anchor}`}</span>
            )}
          </p>
        </div>
      </div>
    );
  }
}
